<template>
  <div style="display: inline-block; position: relative; width: 100%">
    <a-checkbox-group
      v-if="tagType == 'checkbox'"
      @change="onChange"
      :value="arrayValue"
      :disabled="disabled"
    >
      <a-checkbox v-for="(item, key) in dictOptions" :key="key" :value="item.value">
        {{ item.text || item.label }}
      </a-checkbox>
    </a-checkbox-group>

    <a-select
      v-else-if="tagType == 'select'"
      style="width: 100%"
      :value="arrayValue"
      @change="onChange"
      @select="handleSelect"
      :disabled="disabled"
      :mode="mode"
      :placeholder="placeholder"
      :getPopupContainer="(triggerNode) => triggerNode.parentNode"
      :maxTagCount="maxTagCount"
      maxTagPlaceholder="..."
      allowClear
    >
      <a-select-option v-for="(item, index) in dictOptions" :key="index" :value="item.value">
        <span style="display: inline-block; width: 100%" :title="item.text || item.label">
          {{ item.text || item.label }}
        </span>
      </a-select-option>
    </a-select>
  </div>
</template>

<script>
import { ajaxGetDictItems, getDictItemsFromCache } from '@/api/api'
import Vue from 'vue'
import { CURR_GRADECLASS } from '@/store/mutation-types'

export default {
  name: 'JMultiSelectTag',
  props: {
    dictCode: String,
    placeholder: String,
    disabled: Boolean,
    value: String,
    type: String,
    options: Array,
    maxTagCount: Number,
    identityGet: {
      type: String,
      default: '',
    },
    optionalVals: {
      type: String,
      default: '',
    },
    isHasAll: {
      type: Boolean,
      default: false,
    },
    // 过滤value的选项，如果为空数组就是不过滤
    filterValOpts: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dictOptions: [],
      tagType: '',
      arrayValue: !this.value ? [] : this.value.split(','),
      mode: 'multiple',
    }
  },
  created() {
    if (!this.type || this.type === 'list_multi') {
      this.tagType = 'select'
    } else {
      this.tagType = this.type
    }
    //获取字典数据
    //this.initDictData();
  },
  watch: {
    options: function (val) {
      this.setCurrentDictOptions(val)
    },
    dictCode: {
      handler() {
        this.initDictData()
      },
      immediate: true,
    },
    identityGet: {
      handler() {
        this.initDictData()
      },
      immediate: true,
    },
    value(val) {
      if (!val) {
        this.arrayValue = this.isHasAll && val?.includes('all') ? '' : []
      } else {
        this.arrayValue = this.isHasAll && val?.includes('all') ? 'all' : this.value.split(',')
      }
    },
  },
  methods: {
    getPopupContainer(node) {
      console.log('parentNode', node.parentNode)
      return node.parentNode
    },
    initDictData() {
      // 从身份缓存获取信息
      if (this.identityGet.includes('gradeDict') || this.identityGet.includes('classDict')) {
        const keys = this.identityGet.split(',')
        let currOptions = Vue.ls.get(CURR_GRADECLASS)[keys[0]]
        if (currOptions.length) {
          currOptions = currOptions.map((item) => ({
            ...item,
            text: item.name,
            title: item.name,
            value: item.id,
          }))
        }
        if (keys[1] && keys[1] != 'all') {
          currOptions = currOptions.filter(
            (item) => keys.slice(1) && keys.slice(1)?.includes(item.gradeId)
          )
        }
        if (this.isHasAll) {
          currOptions = [
            {
              text: '全部',
              title: '全部',
              value: 'all',
            },
            ...currOptions,
          ]
        }
        if (this.optionalVals?.length) {
          const optionalVals = this.optionalVals?.split(',')
          currOptions = currOptions.filter((item) => optionalVals?.includes(item.value))
        }
        this.dictOptions = currOptions || []
        // this.$emit('setDefaultValue', this.dictOptions)
        return
      }

      //优先从缓存中读取字典配置
      if (this.options && this.options.length > 0) {
        this.dictOptions = [...this.options]
      } else {
        if (getDictItemsFromCache(this.dictCode)) {
          this.dictOptions = this.filterValOpts.length
            ? getDictItemsFromCache(this.dictCode).filter((item) =>
                this.filterValOpts.includes(item.value)
              )
            : getDictItemsFromCache(this.dictCode)
          console.log('dictOptions:', this.dictOptions)
          return
        }
        //根据字典Code, 初始化字典数组
        ajaxGetDictItems(this.dictCode, null).then((res) => {
          if (res.success) {
            this.dictOptions = res.result
          }
        })
      }
    },
    onChange(selectedValue) {
      if (this.isHasAll && selectedValue?.includes('all')) {
        this.mode = 'default'
      } else {
        this.mode = 'multiple'
      }
      // 原有的
      this.$emit('change', Array.isArray(selectedValue) ? selectedValue.join(',') : selectedValue)
      // 因为很多地方已经写了change事件了，所以新增changeSelect事件
      this.$emit('changeSelect', {
        optionArr: selectedValue,
        dictOptions: this.dictOptions,
      })
    },
    handleSelect(val) {
      this.$emit('select', {
        val: val,
        dictOptions:
          this.mode == 'default'
            ? this.dictOptions.filter((item) => item.value != 'all')
            : undefined,
      })
    },
    setCurrentDictOptions(dictOptions) {
      this.dictOptions = dictOptions
    },
    getCurrentDictOptions() {
      return this.dictOptions
    },
  },
  model: {
    prop: 'value',
    event: 'change',
  },
}
</script>
